var _jsxFileName = "/home/circleci/NACL/NACL/packages/nr-vamp-xl-copy-to-clipboard/src/CopyToClipboardPure.js";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component, isValidElement } from 'react';
import PropTypes from 'prop-types';
import { compose, css as glamorCss } from 'glamor';
import Clipboard from 'clipboard';
import isEmpty from 'lodash.isempty';
import debounce from 'lodash.debounce';
import FontAwesome from '@fortawesome/react-fontawesome';
import faPaste from '@fortawesome/fontawesome-free-solid/faPaste';
/* CONSTANTS */

var MAC_OS = 'Mac OS X';
/* PURE COMPONENT */

var CopyToClipboardPure =
/*#__PURE__*/
function (_Component) {
  _inherits(CopyToClipboardPure, _Component);

  function CopyToClipboardPure(props) {
    var _this;

    _classCallCheck(this, CopyToClipboardPure);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CopyToClipboardPure).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      isMacOs: true,
      message: null
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setUserOs", function () {
      var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Function.prototype;

      if (window.navigator && window.navigator.userAgent) {
        _this.setState({
          isMacOs: window.navigator.userAgent.includes(MAC_OS)
        }, cb);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "dismissTooltip", function () {
      return _this.setState({
        message: null
      });
    });

    _this.dismissTooltip = debounce(_this.dismissTooltip, 2500);
    _this.onCopyFailure = _this.onCopyFailure.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.onCopySuccess = _this.onCopySuccess.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.renderIcon = _this.renderIcon.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(CopyToClipboardPure, [{
    key: "componentDidMount",

    /**
     * For forward compatibility with React versions to come, the `componentDidMount` lifecycle
     * hook is used instead of the `componentWillMount` lifecycle method that will eventually be
     * deprecated.
     */
    value: function componentDidMount() {
      var _this2 = this;

      // Ensures the component still works when the required `data-e2e` prop is not provided:
      var _this$props = this.props,
          clipTrigger = _this$props.clipTrigger,
          _this$props$dataE2e = _this$props['data-e2e'],
          dataE2E = _this$props$dataE2e === void 0 ? 'clipper' : _this$props$dataE2e;
      new Promise(function (resolve) {
        return _this2.setUserOs(function () {
          return resolve({});
        });
      }).then(function () {
        _this2.clipboard = new Clipboard(clipTrigger || "#".concat(dataE2E));

        _this2.clipboard.on('error', _this2.onCopyFailure);

        _this2.clipboard.on('success', _this2.onCopySuccess);
      });
    }
    /**
     * When working with single page apps, it's helpful to manage the lifecycle of the DOM more
     * precisely. To clean up the events and objects that the ClipboardJS library creates, we also
     * want to `destroy` them when leaving the view in which they're contained. #perfmatters
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.clipboard) this.clipboard.destroy();
    }
    /**
     * Callback method that is executed when the target text cannot be copied to the clipboard.
     * The copy-to-clipboard functionality is reliant on both the `Selection` and `execCommand`
     * APIs; while the first is supported by all major browsers, the second is not. The
     * ClipboardJS library also exposes a `Clipboard.isSupported()` method to check compatibility.
     * @param {String} action - The clipboard action – either `copy` or `cut`
     * @param {Object} trigger - The DOM node that, when clicked, triggers the clipboard action
     */

  }, {
    key: "onCopyFailure",
    value: function onCopyFailure(_ref) {
      var _this3 = this;

      var action = _ref.action,
          trigger = _ref.trigger;
      var _this$props2 = this.props,
          onError = _this$props2.onError,
          errorText = _this$props2.errorText;
      var isMacOs = this.state.isMacOs;
      this.setState({
        message: errorText || "Press ".concat(isMacOs ? '⌘' : 'Ctrl', "+C to copy")
      }, function () {
        _this3.dismissTooltip();

        if (onError) onError(action, trigger);
      });
    }
    /**
     * This callback method contains the primary logic for clipboard copying. It is passed as the
     * event handler for the `success` event to the ClipboardJS instance.
     * @param {Object} evt - The clipboard event, having an `action`, `text` and `trigger` properties
     */

  }, {
    key: "onCopySuccess",
    value: function onCopySuccess(evt) {
      var _this4 = this;

      var _this$props3 = this.props,
          onSuccess = _this$props3.onSuccess,
          successText = _this$props3.successText;
      evt.clearSelection();
      this.setState({
        message: successText
      }, function () {
        _this4.dismissTooltip();

        if (onSuccess) onSuccess(evt.action, evt.text, evt.trigger);
      });
    }
    /**
     * This method is the first function executed inside the `componentDidMount` lifecycle
     * hook's Promise chain. It simply asserts whether the user is on a Mac device or not. This
     * information is used in setting the appropriate fallback tooltip messaging to show the user
     * should the `Document#execCommand` API be unsupported on his or her machine.
     * @param {Function} cb - An optional callback function passed to the `setState` method
     */

  }, {
    key: "renderIcon",
    value: function renderIcon() {
      var _this$props4 = this.props,
          clipTrigger = _this$props4.clipTrigger,
          dataE2E = _this$props4['data-e2e'],
          disabled = _this$props4.disabled,
          icon = _this$props4.icon,
          label = _this$props4.label,
          styles = _this$props4.styles;
      var iconStyles = styles.icon,
          iconDisabledStyles = styles.iconDisabled;
      var clipboardLabel = "Copy ".concat(label, " to clipboard");
      var iconId = "".concat(dataE2E, "-icon");
      /**
       * By short-circuiting the icon rendering here, the component allows users to explicitly disable
       * icon rendering by passing `null` (or a nullish value) to the `icon` prop. This is also
       * cleaner than bloating the component's API with an additional `disableIcon` prop.
       */

      if (isEmpty(icon) || !isEmpty(clipTrigger)) return null;
      return isValidElement(icon) ? icon : React.createElement(FontAwesome, _extends({
        "aria-hidden": true,
        "aria-label": clipboardLabel,
        "data-e2e": iconId,
        icon: icon,
        key: iconId,
        role: "presentation",
        title: clipboardLabel
      }, compose([iconStyles, disabled && iconDisabledStyles]), {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 124
        },
        __self: this
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          action = _this$props5.action,
          children = _this$props5.children,
          dataE2E = _this$props5['data-e2e'],
          disabled = _this$props5.disabled,
          label = _this$props5.label,
          onClick = _this$props5.onClick,
          _this$props5$styles = _this$props5.styles,
          buttonStyles = _this$props5$styles.button,
          buttonDisabledStyles = _this$props5$styles.buttonDisabled,
          buttonWrapperStyles = _this$props5$styles.buttonWrapper,
          clipContentStyles = _this$props5$styles.clipContent,
          labelStyles = _this$props5$styles.label,
          labelDisabledStyles = _this$props5$styles.labelDisabled,
          rootStyles = _this$props5$styles.root,
          tooltipStyles = _this$props5$styles.tooltip,
          tooltipContainerStyles = _this$props5$styles.tooltipContainer;
      var message = this.state.message;
      return React.createElement("div", _extends({
        "data-e2e": dataE2E
      }, glamorCss(rootStyles), {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 160
        },
        __self: this
      }), !isEmpty(label) && React.createElement("strong", _extends({}, compose([labelStyles, disabled && labelDisabledStyles]), {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 162
        },
        __self: this
      }), label), React.createElement("div", _extends({}, glamorCss(buttonWrapperStyles), {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 164
        },
        __self: this
      }), React.createElement("button", {
        className: "clipboard ".concat(compose([buttonStyles, disabled && buttonDisabledStyles])),
        "data-clipboard-action": action,
        "data-clipboard-target": disabled ? null : "#".concat(dataE2E, "-target"),
        "data-e2e": "".concat(dataE2E, "-clipboard-button"),
        disabled: disabled,
        id: dataE2E || 'clipper',
        onClick: onClick,
        type: "button",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 165
        },
        __self: this
      }, React.createElement("span", _extends({
        "data-e2e": "".concat(dataE2E, "-clip-content"),
        id: "".concat(dataE2E, "-target")
      }, glamorCss(clipContentStyles), {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 175
        },
        __self: this
      }), children), this.renderIcon()), React.createElement("div", _extends({
        "data-e2e": "".concat(dataE2E, "-tooltip-container")
      }, glamorCss(tooltipContainerStyles), {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 184
        },
        __self: this
      }), message && React.createElement("span", _extends({
        "data-e2e": "".concat(dataE2E, "-tooltip")
      }, glamorCss(tooltipStyles), {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 186
        },
        __self: this
      }), message))));
    }
  }]);

  return CopyToClipboardPure;
}(Component);
/* TYPE-CHECKING */


CopyToClipboardPure.propTypes = {
  /** Cut or copy directive for ClipboardJS. Cut is only possible on `input` or `textarea`. */
  action: PropTypes.oneOf(['copy', 'cut']),

  /** The cuttable/copyable content. */
  children: PropTypes.node,

  /** Specify DOM node id of element that should execute clipboard action (e.g., `#trigger`).
   *  Only necessary if you're using custom children with your own clip button. */
  clipTrigger: PropTypes.string,

  /** Unique id used for E2E testing and under the hood for ClipboardJS. */
  'data-e2e': PropTypes.string.isRequired,

  /** If `true`, clipboard events are disabled. */
  disabled: PropTypes.bool,

  /** Custom tooltip message shown for browsers that do not support copying to clipboard. */
  errorText: PropTypes.string,

  /** Any icon declaration understood by FontAwesome (e.g., `['fas', 'copy']`, `faCoffee`). */
  icon: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.element, PropTypes.object, PropTypes.string]),

  /** Custom node used to label to copyable text. */
  label: PropTypes.node,

  /** Callback function executed on button click. */
  onClick: PropTypes.func,

  /** Callback function that fires in unsupported browsers. `function(evt.action, evt.trigger) =>
   *  {}` */
  onError: PropTypes.func,

  /** Callback function fired after successful copy. `function(evt.action, evt.text, evt.trigger) =>
   *  {}` */
  onSuccess: PropTypes.func,

  /** Extends and overrides Nike MUI styles. */
  styles: PropTypes.shape({
    button: PropTypes.shape({}),
    buttonDisabled: PropTypes.shape({}),
    buttonWrapper: PropTypes.shape({}),
    clipContent: PropTypes.shape({}),
    icon: PropTypes.shape({}),
    iconDisabled: PropTypes.shape({}),
    label: PropTypes.shape({}),
    labelDisabled: PropTypes.shape({}),
    root: PropTypes.shape({}),
    tooltip: PropTypes.shape({}),
    tooltipContainer: PropTypes.shape({})
  }),

  /** Custom tooltip message shown on cut/copy. */
  successText: PropTypes.string
};
CopyToClipboardPure.defaultProps = {
  action: 'copy',
  disabled: false,
  icon: faPaste,
  styles: {
    button: {},
    buttonDisabled: {},
    buttonWrapper: {},
    clipContent: {},
    icon: {},
    iconDisabled: {},
    label: {},
    labelDisabled: {},
    root: {},
    tooltip: {},
    tooltipContainer: {}
  },
  successText: 'Copied!'
};
CopyToClipboardPure.displayName = 'CopyToClipboardPure';
/* EXPORTS */

export default CopyToClipboardPure;